import { NETWORK_INPUT_SEND_MS } from "./networkBootstrap.js";

const INPUT_SEND_WINDOW = 40;
const MAX_INPUT_SEND_STEPS_PER_CALL = 5;
const MAX_INPUT_ACCUMULATOR_MS = NETWORK_INPUT_SEND_MS * MAX_INPUT_SEND_STEPS_PER_CALL;

function pushInputIntervalTelemetry(scene, time) {
  if (!Array.isArray(scene.netInputSendIntervalsMs)) scene.netInputSendIntervalsMs = [];
  if (Number.isFinite(scene.netLastInputSentAt) && scene.netLastInputSentAt > 0) {
    const interval = time - scene.netLastInputSentAt;
    if (Number.isFinite(interval) && interval > 0 && interval < 1000) {
      scene.netInputSendIntervalsMs.push(interval);
      if (scene.netInputSendIntervalsMs.length > INPUT_SEND_WINDOW) {
        scene.netInputSendIntervalsMs.splice(0, scene.netInputSendIntervalsMs.length - INPUT_SEND_WINDOW);
      }
    }
  }
}

function refreshInputSendStats(scene) {
  const intervals = scene.netInputSendIntervalsMs;
  const avgMs = intervals.length
    ? (intervals.reduce((acc, value) => acc + value, 0) / intervals.length)
    : 0;
  scene.netInputSendStats = {
    avgMs,
    hz: avgMs > 0 ? (1000 / avgMs) : 0,
    targetMs: NETWORK_INPUT_SEND_MS,
    targetHz: 1000 / NETWORK_INPUT_SEND_MS,
  };
}

function sendInputPacket(scene, time) {
  const p = scene.playerEntity;
  if (!p) return;
  pushInputIntervalTelemetry(scene, time);
  scene.netLastInputSentAt = time;
  scene.netInputSeq += 1;
  scene.netClient.sendInput(scene.netInputSeq, {
    ...scene.netInputFlags,
    facing: p.facing,
    mapId: scene.mapId,
    anchorX: p.x,
    anchorY: p.y,
    anchorVy: p.vy,
    anim: scene.anim?.current || "Idle",
  });
}

export function sendLocalPlayerInput(scene, time, frameDtMs = 0) {
  if (!scene.netClient || scene.netStatus !== "connected") return;
  const safeFrameDt = Number.isFinite(frameDtMs) ? Math.max(0, frameDtMs) : 0;
  if (!Number.isFinite(scene.netInputAccumulatorMs)) scene.netInputAccumulatorMs = 0;
  if (!Number.isFinite(scene.netLastInputSchedulerAtMs)) scene.netLastInputSchedulerAtMs = time;

  scene.netInputAccumulatorMs = Math.min(
    MAX_INPUT_ACCUMULATOR_MS,
    scene.netInputAccumulatorMs + safeFrameDt
  );
  let sendSteps = 0;
  while (
    scene.netInputAccumulatorMs >= NETWORK_INPUT_SEND_MS
    && sendSteps < MAX_INPUT_SEND_STEPS_PER_CALL
  ) {
    sendInputPacket(scene, time - scene.netInputAccumulatorMs + NETWORK_INPUT_SEND_MS);
    scene.netInputAccumulatorMs -= NETWORK_INPUT_SEND_MS;
    sendSteps += 1;
  }
  scene.netLastInputSchedulerAtMs = time;

  // Emit one immediate packet after connect so remotes can bootstrap promptly.
  if (scene.netLastInputSentAt <= 0 && sendSteps === 0) {
    sendInputPacket(scene, time);
    scene.netInputAccumulatorMs = 0;
  }
  refreshInputSendStats(scene);
}

export function updateNetworkRuntime(scene, time, dtScale) {
  const remoteMotion = scene.updateRemotePlayers(dtScale);
  if (remoteMotion && typeof remoteMotion === "object") {
    scene.netRemoteMotionStats = remoteMotion;
  }
  for (const [id, proj] of scene.netProjectilesById.entries()) {
    if (!proj || proj.markedForRemoval || !proj.sprite) scene.netProjectilesById.delete(id);
  }
  for (const [token, proj] of scene.netPendingProjectilesByToken.entries()) {
    if (!proj || proj.markedForRemoval || !proj.sprite || !proj.pendingNetworkOwnership) {
      scene.netPendingProjectilesByToken.delete(token);
    }
  }
  scene.updateNetworkStartupPhase?.();
  scene.ui?.setNetworkDebug?.({
    wsUrl: scene.netWsUrl,
    playerId: scene.netPlayerId,
    sessionId: scene.netSessionId,
    status: scene.netStatus,
    tickRate: scene.netServerTickRate,
    rttMs: scene.netClient?.lastRttMs,
    remoteMotion: scene.netRemoteMotionStats,
    inputSend: scene.netInputSendStats,
  });
}
